import { Box, Typography } from "@mui/material";

export function DailyCalendar({
  year,
  month,
  data,
  onPrev: _onPrev,
  onNext: _onNext,
  onDayClick,
}: {
  year: number;
  month: number;
  data: { name: string; 合計: number }[];
  onPrev: () => void;
  onNext: () => void;
  onDayClick?: (day: number) => void;
}) {
  const today = new Date();
  const todayDate =
    today.getFullYear() === year && today.getMonth() + 1 === month
      ? today.getDate()
      : -1;
  const firstDayOfMonth = new Date(year, month - 1, 1).getDay();
  const daysInMonth = new Date(year, month, 0).getDate();
  const countMap: { [day: number]: number } = {};
  data.forEach((d) => {
    // "YYYY年M月D日" 形式または純粋な数字文字列（例: "8"）から日を抽出
    const dayMatch = d.name.match(/^(\d+)$|(\d+)日/);
    const day = dayMatch ? parseInt(dayMatch[1] ?? dayMatch[2], 10) : NaN;
    if (!isNaN(day) && day >= 1 && day <= 31) countMap[day] = d.合計;
  });
  const cells: (number | null)[] = [];
  for (let i = 0; i < firstDayOfMonth; i++) cells.push(null);
  for (let d = 1; d <= daysInMonth; d++) cells.push(d);
  while (cells.length % 7 !== 0) cells.push(null);
  const weeks: (number | null)[][] = [];
  for (let i = 0; i < cells.length; i += 7) {
    weeks.push(cells.slice(i, i + 7));
  }
  const dayHeaders = ["日", "月", "火", "水", "木", "金", "土"];
  return (
    <Box>
      <Box sx={{ display: "flex", alignItems: "center", mb: 1, justifyContent: "center" }}>
        <Typography sx={{ fontWeight: 600, fontSize: 13 }}>
          {year}年{String(month).padStart(2, "0")}月
        </Typography>
      </Box>
      <Box sx={{ border: "1px solid #ddd", borderRadius: 1, overflow: "hidden" }}>
        <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", bgcolor: "#607d8b" }}>
          {dayHeaders.map((h, i) => (
            <Box key={h} sx={{ textAlign: "center", py: 0.5, fontSize: 11, fontWeight: 600, color: i === 0 ? "#FF6B6B" : i === 6 ? "#64B5F6" : "white" }}>
              {h}
            </Box>
          ))}
        </Box>
        {weeks.map((week, wi) => (
          <Box key={wi} sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)" }}>
            {week.map((day, di) => {
              if (day === null) {
                return <Box key={di} sx={{ borderRight: "1px solid #eee", borderBottom: "1px solid #eee", minHeight: 44 }} />;
              }
              const isToday = day === todayDate;
              const count = countMap[day] ?? 0;
              const clickable = !!onDayClick;
              return (
                <Box
                  key={di}
                  onClick={clickable ? () => onDayClick(day) : undefined}
                  sx={{
                    borderRight: "1px solid #eee",
                    borderBottom: "1px solid #eee",
                    minHeight: 44,
                    p: 0.3,
                    textAlign: "center",
                    bgcolor: isToday ? "#B3E5FC" : undefined,
                    cursor: clickable ? "pointer" : undefined,
                    "&:hover": clickable ? { bgcolor: isToday ? "#81D4FA" : "#F5F5F5" } : undefined,
                  }}
                >
                  <Typography sx={{ fontSize: 11, fontWeight: isToday ? 700 : 400, color: di === 0 ? "#e53935" : di === 6 ? "#1565C0" : isToday ? "#0277BD" : "inherit", lineHeight: 1.2 }}>
                    {day}
                  </Typography>
                  <Typography sx={{ fontSize: 10, color: "text.secondary", lineHeight: 1.2 }}>
                    {count}件
                  </Typography>
                </Box>
              );
            })}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
